import { Maximize2 } from "lucide-react";

export const VIEW_PRESETS = [
  { id: "iso", label: "Iso" },
  { id: "front", label: "Front" },
  { id: "back", label: "Back" },
  { id: "left", label: "Left" },
  { id: "right", label: "Right" },
  { id: "top", label: "Top" },
];

export default function ViewControlBar({ activeView, onSelect, onFit, className = "" }) {
  return (
    <div
      className={`absolute top-3 left-3 z-10 flex flex-wrap items-center gap-1 rounded-lg border border-white/10 bg-black/55 p-1 backdrop-blur-sm ${className}`}
    >
      {VIEW_PRESETS.map(({ id, label }) => (
        <button
          key={id}
          type="button"
          onClick={() => onSelect(id)}
          className={
            activeView === id
              ? "rounded-md bg-sky-500/25 px-2 py-1 text-[11px] font-medium text-sky-100"
              : "rounded-md px-2 py-1 text-[11px] text-white/65 hover:bg-white/10 hover:text-white/90"
          }
        >
          {label}
        </button>
      ))}
      {onFit && (
        <button
          type="button"
          onClick={onFit}
          title="Fit to view"
          className="rounded-md px-1.5 py-1 text-white/65 hover:bg-white/10 hover:text-white/90"
        >
          <Maximize2 className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
